module.exports = __webpack_public_path__ + "static/media/program1.f0eef891.jpg";